var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgItemTablet8(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "img_\xED\x95\xAD\xEB\xAA\xA98"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M74.9996 0.00538421C116.391 0.00539144 149.999 33.6136 149.999 75.005L149.999 150.005L74.9996 150.005C33.6082 150.005 -2.03504e-05 116.396 -1.31133e-05 75.005C-5.87625e-06 33.6136 33.6082 0.00537697 74.9996 0.00538421Z",
    fill: "#E4E1FB"
  }), /*#__PURE__*/React.createElement("g", {
    id: 8
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M23.6117 47.2246C10.581 47.2246 0.000667572 36.6442 0.000667572 23.6136V0.00262451H23.6117C36.6423 0.00262451 47.2227 10.583 47.2227 23.6136C47.2227 36.6442 36.6423 47.2246 23.6117 47.2246Z",
    fill: "#3C2163"
  }), /*#__PURE__*/React.createElement("path", {
    id: "8_2",
    d: "M23.125 33.7474C27.1479 33.7474 29.981 31.485 29.9999 28.3102C29.981 25.8007 28.2434 23.7285 26.0525 23.3672V23.2722C27.9412 22.8159 29.2255 21.0289 29.2444 18.9186C29.2255 15.9339 26.638 13.7476 23.125 13.7476C19.5743 13.7476 16.9867 15.9339 16.9867 18.9186C16.9867 21.0289 18.2522 22.8159 20.1786 23.2722V23.3672C17.9689 23.7285 16.2313 25.8007 16.2502 28.3102C16.2313 31.485 19.0454 33.7474 23.125 33.7474ZM23.125 22.3977C20.8964 22.3977 19.3287 21.0669 19.3287 19.0897C19.3287 17.1506 20.8208 15.8388 23.125 15.8388C25.3726 15.8388 26.9024 17.1506 26.9024 19.0897C26.9024 21.0669 25.3159 22.3977 23.125 22.3977ZM23.125 31.6181C20.3297 31.6181 18.611 30.2303 18.6488 28.1771C18.611 26.0288 20.5186 24.4509 23.125 24.4509C25.7125 24.4509 27.6012 26.0288 27.6012 28.1771C27.6012 30.2303 25.8825 31.6181 23.125 31.6181Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\xEC\x95\x84\xEC\x9D\xB4\xEC\xBD\x98"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M96.1811 46.7627H51.2188V115.425H105.048V55.5879L96.1811 46.7627Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M105.046 116.248H51.217C50.7625 116.248 50.3906 115.879 50.3906 115.427V46.7641C50.3906 46.3122 50.7625 45.9424 51.217 45.9424H96.1793C96.4024 45.9424 96.609 46.0328 96.766 46.1807L105.633 55.0059C105.79 55.162 105.873 55.3675 105.873 55.5893V115.427C105.873 115.879 105.501 116.248 105.046 116.248ZM52.0433 114.605H104.22V55.9262L95.8322 47.5858H52.0433V114.605Z",
    fill: "#3C2163"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M96.1816 55.5904H105.048L96.1816 46.7651V55.5904Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M105.047 56.4123H96.1799C95.7254 56.4123 95.3535 56.0425 95.3535 55.5905V46.7653C95.3535 46.4366 95.5518 46.1326 95.8659 46.0093C96.1716 45.8779 96.5269 45.9518 96.7666 46.1901L105.633 55.0153C105.873 55.2536 105.939 55.607 105.815 55.911C105.691 56.215 105.386 56.4205 105.055 56.4205L105.047 56.4123ZM97.0062 54.7688H103.055L97.0062 48.7539V54.7688Z",
    fill: "#3C2163"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M63.9763 73.083H59.1504V77.8818H63.9763V73.083Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M64.8009 78.6976H58.3223V72.2554H64.8009V78.6976ZM59.975 77.0542H63.1482V73.8988H59.975V77.0542Z",
    fill: "#8FDAE2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M81.4589 76.3036H68.799C68.3445 76.3036 67.9727 75.9338 67.9727 75.4819C67.9727 75.0299 68.3445 74.6602 68.799 74.6602H81.4589C81.9134 74.6602 82.2852 75.0299 82.2852 75.4819C82.2852 75.9338 81.9134 76.3036 81.4589 76.3036Z",
    fill: "#3C2163"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M63.9763 83.271H59.1504V88.0698H63.9763V83.271Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M64.8009 88.8929H58.3223V82.4507H64.8009V88.8929ZM59.975 87.2495H63.1482V84.0941H59.975V87.2495Z",
    fill: "#8FDAE2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M81.4589 86.494H68.799C68.3445 86.494 67.9727 86.1242 67.9727 85.6723C67.9727 85.2204 68.3445 84.8506 68.799 84.8506H81.4589C81.9134 84.8506 82.2852 85.2204 82.2852 85.6723C82.2852 86.1242 81.9134 86.494 81.4589 86.494Z",
    fill: "#3C2163"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M63.9763 93.4683H59.1504V98.2671H63.9763V93.4683Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M64.8009 99.0902H58.3223V92.6479H64.8009V99.0902ZM59.975 97.4468H63.1482V94.2914H59.975V97.4468Z",
    fill: "#8FDAE2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M81.4589 96.6913H68.799C68.3445 96.6913 67.9727 96.3215 67.9727 95.8696C67.9727 95.4176 68.3445 95.0479 68.799 95.0479H81.4589C81.9134 95.0479 82.2852 95.4176 82.2852 95.8696C82.2852 96.3215 81.9134 96.6913 81.4589 96.6913Z",
    fill: "#3C2163"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M100.929 76.1128C94.0285 76.1128 88.434 81.6758 88.434 88.5371C88.434 91.5199 89.4917 94.2563 91.2519 96.4009C90.2107 99.8275 86.5664 100.97 86.5664 100.97H100.697C100.78 100.97 100.854 100.97 100.937 100.97C107.837 100.97 113.431 95.4067 113.431 88.5453C113.431 81.684 107.837 76.121 100.937 76.121L100.929 76.1128Z",
    fill: "#EAEAF9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M102.152 101.782H86.5585L86.3105 100.18C86.3105 100.18 89.2772 99.2102 90.3184 96.556C88.5665 94.2634 87.5997 91.4367 87.5997 88.5361C87.5997 81.231 93.5743 75.29 100.921 75.29C108.267 75.29 114.242 81.231 114.242 88.5361C114.242 95.4385 108.903 101.133 102.111 101.733L102.144 101.782H102.152ZM98.6481 100.089L100.921 100.139C107.358 100.139 112.589 94.929 112.589 88.5361C112.589 82.1431 107.35 76.9335 100.921 76.9335C94.4915 76.9335 89.2524 82.1431 89.2524 88.5361C89.2524 91.2067 90.1862 93.8115 91.8885 95.874L92.1694 96.2109L92.0455 96.63C91.5662 98.1994 90.6159 99.3416 89.6573 100.139H98.706L98.6564 100.089H98.6481Z",
    fill: "#3C2163"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M106.657 83.7471H95.7988V85.3905H106.657V83.7471Z",
    fill: "#F58B93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M106.657 88.2979H95.7988V89.9413H106.657V88.2979Z",
    fill: "#F58B93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M106.657 92.8535H95.7988V94.4969H106.657V92.8535Z",
    fill: "#F58B93"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M114.161 66.3829L111.242 69.3159L114.16 72.2499L117.079 69.3169L114.161 66.3829Z",
    fill: "#F7D979"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M114.182 72.7899C114.04 72.7899 113.911 72.7327 113.812 72.6325L110.894 69.6999C110.681 69.4853 110.681 69.1563 110.894 68.9417L113.798 66.0091C113.997 65.8088 114.353 65.8088 114.552 66.0091L117.469 68.9417C117.683 69.1563 117.683 69.4853 117.469 69.6999L114.552 72.6325C114.452 72.7327 114.324 72.7899 114.182 72.7899ZM112.019 69.3137L114.182 71.4881L116.345 69.3137L114.182 67.1392L112.019 69.3137Z",
    fill: "#705699"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M79.4449 61.7231H58.8438V63.3666H79.4449V61.7231Z",
    fill: "#2F4382"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M66.0083 65.5854H58.8438V67.2289H66.0083V65.5854Z",
    fill: "#2F4382"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M61.911 105.539H59.498V107.182H61.911V105.539Z",
    fill: "#2F4382"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M66.6298 105.539H64.2168V107.182H66.6298V105.539Z",
    fill: "#2F4382"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M71.3466 105.539H68.9336V107.182H71.3466V105.539Z",
    fill: "#2F4382"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M40.1704 96.162H38.3043C37.8539 96.162 37.5 95.8074 37.5 95.3561C37.5 94.9049 37.8539 94.5503 38.3043 94.5503H40.1704C40.6208 94.5503 40.9747 94.9049 40.9747 95.3561C40.9747 95.8074 40.6208 96.162 40.1704 96.162Z",
    fill: "#F58B93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M45.3345 96.162H43.4684C43.018 96.162 42.6641 95.8074 42.6641 95.3561C42.6641 94.9049 43.018 94.5503 43.4684 94.5503H45.3345C45.7849 94.5503 46.1388 94.9049 46.1388 95.3561C46.1388 95.8074 45.7849 96.162 45.3345 96.162Z",
    fill: "#F58B93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M41.8278 94.5193C41.3773 94.5193 41.0234 94.1647 41.0234 93.7134V91.86C41.0234 91.4088 41.3773 91.0542 41.8278 91.0542C42.2782 91.0542 42.6321 91.4088 42.6321 91.86V93.7134C42.6321 94.1647 42.2782 94.5193 41.8278 94.5193Z",
    fill: "#F58B93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M41.8278 99.6941C41.3773 99.6941 41.0234 99.3395 41.0234 98.8883V97.0187C41.0234 96.5675 41.3773 96.2129 41.8278 96.2129C42.2782 96.2129 42.6321 96.5675 42.6321 97.0187V98.8883C42.6321 99.3395 42.2782 99.6941 41.8278 99.6941Z",
    fill: "#F58B93"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgItemTablet8);
export default __webpack_public_path__ + "static/media/item_tablet_8.8b98db551641c8c817118249fa1d33c1.svg";
export { ForwardRef as ReactComponent };